import { render, staticRenderFns } from "./Ksyun.vue?vue&type=template&id=6ac08572"
import script from "./Ksyun.vue?vue&type=script&lang=js"
export * from "./Ksyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports